import styled from 'styled-components';

const PageTitle = styled.h2`
  font-size: 1.4rem;
`;

export default PageTitle;
